import { render } from "./SlideShowFeature.vue?vue&type=template&id=46162add"
import script from "./SlideShowFeature.vue?vue&type=script&lang=js"
export * from "./SlideShowFeature.vue?vue&type=script&lang=js"

import "./SlideShowFeature.vue?vue&type=style&index=0&id=46162add&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__